import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsPage from "components/pages/NotificationsPage";
import Classes, { Notification, NotificationDetail } from "model";

export default function CaptureNotifiList(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const notification = Notification.initByID("1");
    const detailUpdates = NotificationDetail.getByNotificationID(notification.id).map(detail => {
        detail.isEnabled = "false";

        return NotificationDetail.update(detail);
    }, []);

    BCMSRecord.batch([
        Notification.update({ ...notification.record, "activated": "false" }),
        ...detailUpdates
    ], controller, Classes);

    return <NotificationsPage />
}